import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(status === "cancel" ? "cancelled" : "checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (status === "cancel" || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "failed" || data.payment_status === "failed") { setState("failed"); return; }
      } catch { /* keep trying */ }
      tries += 1;
      if (tries >= 8) { setState("pending"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, status]);

  const map = {
    checking: { title: "Confirming Payment…", body: "Please wait while we confirm your payment.", color: "#8CE63C" },
    paid: { title: "Payment Successful!", body: "Thank you for your order. Our team will be in touch with delivery details shortly.", color: "#8CE63C" },
    pending: { title: "Payment Processing", body: "Your payment is still processing. We'll email you once it's confirmed.", color: "#FDE047" },
    failed: { title: "Payment Failed", body: "Your payment could not be completed. Please try again.", color: "#F87171" },
    cancelled: { title: "Checkout Cancelled", body: "No charge was made. You can continue browsing and try again anytime.", color: "#FCA5A5" },
  };
  const s = map[state] || map.checking;

  return (
    <Layout>
      <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="payment-result">
        <div className="rounded-2xl border border-[#232f25] bg-[#111712] p-8 sm:p-12">
          <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight" style={{ color: s.color }} data-testid="payment-result-title">{s.title}</h1>
          <p className="text-[#9EABA0] text-sm sm:text-base leading-relaxed mt-4">{s.body}</p>
          {info?.product_name && state === "paid" && (
            <p className="text-sm text-[#f4f7f4] mt-4">{info.product_name} — <span className="text-[#8CE63C] font-bold">${info.amount}</span></p>
          )}
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="px-6 py-3 rounded-md bg-[#8CE63C] text-[#080b08] text-sm font-bold uppercase tracking-wide hover:bg-[#9df04f] transition-colors">Back to Products</Link>
            <Link to="/contact" className="px-6 py-3 rounded-md bg-[#0d120e] border border-[#232f25] text-sm font-semibold text-[#f4f7f4] hover:border-[#8CE63C]/50 transition-colors">Contact Us</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
